<template>
  <div class="wrap">
    <div class="type">
      <span class="title"> 2024 年 01 月 全年一次性奖金收入</span>
      <div class="summary">
        申报总人数：{{ userAnswer.length }} 收入总额：{{ summaryInfo.srz }}元 免税收入合计:{{ summaryInfo.msSrz }}元
      </div>
    </div>

    <main class="main-box">
      <div class="op-wrap">
        <el-space :size="14">
          <el-button @click="changeTab">返回</el-button>
          <el-button type="primary" @click="addData">添加</el-button>
          <el-dropdown>
            <el-button type="primary">
              导入
              <el-icon style="margin-left: 3px;">
                <ArrowDown/>
              </el-icon>
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <el-link :underline="false">导入文件</el-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-link :underline="false"
                           href="#"
                  >下载模板
                  </el-link>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-space>

        <el-space :size="14">
          <el-button>
            导出
            <el-icon style="margin-left: 3px;">
              <ArrowDown/>
            </el-icon>
          </el-button>

          <el-button>展开查询条件</el-button>
        </el-space>
      </div>

      <el-table
          :data="userAnswer"
          border
          show-summary
          :summary-method="getSummaries"
          max-height="calc(100vh - 300px)"
      >
        <el-table-column type="selection" width="55" align="center"/>
        <el-table-column label="工号" prop="employeesNo" align="center" min-width="120"/>
        <el-table-column label="姓名" prop="name" align="center" min-width="120"/>
        <el-table-column label="证照类型" prop="certificateType" align="center" min-width="120"/>
        <el-table-column label="证照号码" prop="idNumber" align="center" min-width="120"/>

        <el-table-column label="全年一次性奖金额" align="center" min-width="200">
          <template #default="{row}">
            <span v-if="!row.isEditMode">
              {{ row.Answer_CurrentIncome != null && row.Answer_CurrentIncome.toFixed(2) }}
              <el-icon
                  color="#666666"
                  style="cursor: pointer;padding-left: 3px;"
                  @click="row.isEditMode = !row.isEditMode"
              ><EditPen/></el-icon>
            </span>
            <div
                style="display: flex;align-items: center;"
                v-else>
              <el-input-number
                  v-model="row.Answer_CurrentIncome"
                  :precision="2"
                  class="num-input"
                  :controls="false"
              />
              <el-icon
                  style="cursor: pointer;padding-left: 3px;position: relative;top: -2px;"
                  @click="row.isEditMode = false"
                  size="19px"
              >
                <Check/>
              </el-icon>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="免税收入" align="center" min-width="120">
          <template #default="{row}">
            <span>{{ row.Answer_CurrentExemptIncome != null && row.Answer_CurrentExemptIncome.toFixed(2) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="其他" align="center" min-width="120">
          <template #default="{row}">
            <span>{{ row.Answer_Other != null && row.Answer_Other.toFixed(2) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="准予扣除的捐赠额" align="center" min-width="200">
          <template #default="{row}">
            <span>{{
                row.Answer_PreDeductibleContributions != null && row.Answer_PreDeductibleContributions.toFixed(2)
              }}</span>
          </template>
        </el-table-column>

        <el-table-column label="减免税额" align="center" min-width="120">
          <template #default="{row}">
            <span>{{ row.TaxRelief != null && row.TaxRelief.toFixed(2) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="已缴税额" align="center" min-width="120">
          <template #default="{row}">
            <span>{{ row.Answer_TheAmountTaxWithheld != null && row.Answer_TheAmountTaxWithheld.toFixed(2) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="备注" prop="Answer_Remark" align="center" min-width="160"/>
      </el-table>
    </main>

    <one52-add-dialog
        v-model:visible="addVis"
        @confirm="afterAdd"
    />

  </div>
</template>

<script setup>
import One52AddDialog from "./one52AddDialog.vue";
import {useTaxStore} from "@/store/modules/tax.js";
import Big from "big.js";

const taxStore = useTaxStore();
const {userAnswer} = storeToRefs(taxStore);

const emits = defineEmits(['changeTab'])
const changeTab = () => {
  emits('changeTab', 'default')
}

const summaryInfo = computed(() => {
  let srz = new Big(0), msSrz = new Big(0)
  userAnswer.value.forEach(row => {
    srz = srz.plus(row.Answer_CurrentIncome) //收入总额
    msSrz = msSrz.plus(row.Answer_CurrentExemptIncome) //免税收入总
  })
  return {
    srz: srz.toFixed(2),
    msSrz: msSrz.toFixed(2),
  }
})

//表格汇总
function getSummaries({columns}) {
  return ['', '合计', `记录数：${userAnswer.value.length}`, '-', '-']
}

const addVis = ref(false)

function addData() {
  addVis.value = true
}

function afterAdd(data) {
  userAnswer.value.push(data)
}
</script>


<style scoped lang="scss">
.wrap {
  .type {
    height: 60px;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .title {
      height: 20px;
      border-left: 4px solid var(--el-color-primary);
      box-sizing: border-box;
      line-height: 20px;
      text-indent: 12px;
      font-weight: bold;
    }

    .summary {
      font-size: 14px;
      margin-left: 20px;
    }
  }

  .main-box {
    .op-wrap {
      display: flex;
      justify-content: space-between;
      padding-bottom: 10px;
    }

    :deep(.num-input) {
      width: 130px;

      .el-input__inner {
        text-align: left;
      }
    }
  }


}
</style>
